module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.toggleReason
      }),
      expression: "{methods:toggleReason}"
    }],
    staticClass: "item"
  }, [_c('span', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.checkIn,
        normal: 0
      }),
      expression: "{methods:checkIn,normal:0}"
    }],
    staticClass: "check",
    class: {
      checked: _vm.student.checked
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "name",
    domProps: {
      "textContent": _vm._s(_vm.student.userName)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "course",
    class: {
      warning: _vm.student.isArrears
    }
  }, [_vm._v("已上" + _vm._s(_vm.student.aboveCourse) + "节/共" + _vm._s(_vm.student.totalCourse) + "节")]), _vm._v(" "), _c('span', {
    staticClass: "right-arrow"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.student.visible),
      expression: "student.visible"
    }],
    staticClass: "reason"
  }, [_c('div', {
    staticClass: "right"
  }), _vm._v(" "), _c('div', {
    staticClass: "radio-list-wrapper"
  }, [_c('label', {
    staticClass: "radio-title"
  }, [_vm._v("缺勤原因")]), _vm._v(" "), _c('ul', _vm._l((_vm.reasons), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.itemChecked({
            index: index
          })
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.chooseReason),
        expression: "chooseReason"
      }],
      staticClass: "radio-input",
      attrs: {
        "type": "radio",
        "disabled": ""
      },
      domProps: {
        "value": item.dictValue,
        "checked": _vm._q(_vm.chooseReason, item.dictValue)
      },
      on: {
        "change": function($event) {
          _vm.chooseReason = item.dictValue
        }
      }
    }), _vm._v(" "), _c('span', {
      class: item.dictValue === _vm.student.dictCodeId ? 'selected' : 'radio-core'
    }), _vm._v(" "), _c('span', {
      staticClass: "radio-label"
    }, [_vm._v(_vm._s(item.dictLabel))])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13d025ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckInItem.vue
// module id = 758
// module chunks = 1